import styled from '../../utils/styled';

export { BorderedBox } from './BorderedBox';

export const PreserveNewline = styled('span')(() => ({
  whiteSpace: 'pre-wrap',
}));

export const GridWrapper = styled('div')(() => ({
  width: '100%',
  overflow: 'auto',
}));
